import { Separator } from "@app/components/core/Separator/Separator"
import { useGetStrings } from "@app/store/service/cmsService"
import { getPriceString } from "@app/utils/localeUtils"
import { classNamez } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"

export const PriceSummaryRow = ({ text, price, bold, pricePrefix, listItem = true }) => {
	const Tag = listItem ? "li" : "div"

	return (
		<Tag className="flex flex-justify-between">
			<div className={classNamez({ regular: bold })}>{text}:</div>
			<div className={classNamez({ regular: bold })}>
				{pricePrefix} {getPriceString(price, undefined, false)}
			</div>
		</Tag>
	)
}

export function PriceSummary({ formattedOrder, hideTransporter, showTransporterFromPrice }) {
	const { data: stringData } = useGetStrings()
	const {
		orderOverviewPriceOverviewTitle,
		orderOverviewTransportCosts,
		orderOverviewPriceSum,
		orderOverviewVAT,
		orderOverviewDiscountCosts,
		orderOverviewSubTotalCosts,
		orderOverviewAlreadyPaid,
		orderOverviewOpenAmount,
		orderOverviewCreditAmount,
		paymentMethod: paymentMethodString,
		freeOrder,
		from,
	} = stringData || {}
	const paymentMethod = useSelector("order.payment")
	if (!formattedOrder) {
		return null
	}

	return (
		<div className="mt-4">
			<h2 id="order-overview-price-summary-title" className="f4 regular">
				{orderOverviewPriceOverviewTitle}
			</h2>
			<Separator />

			<div className="color-bg-secondary-100">
				<ol className="p-3 f5" aria-labelledby="order-overview-price-summary-title">
					{(paymentMethod || formattedOrder.payAmount <= 0) && (
						<li className="flex mb-2">
							<span>
								<span className="regular">{paymentMethodString}: </span>
								<span style={{ fontStyle: "italic" }} className="color-fg-secondary">
									{formattedOrder.payAmount <= 0 ? freeOrder : paymentMethod.paymentGroup}
								</span>
							</span>
						</li>
					)}

					{(formattedOrder.transporterAmount && formattedOrder.transporterAmount > 0) ||
					(formattedOrder.totalDiscountAmount && formattedOrder.totalDiscountAmount < 0) ? (
						<li className="mb-3">
							<PriceSummaryRow
								text={orderOverviewSubTotalCosts}
								price={formattedOrder.subtotal.grossAmount - (formattedOrder.transporterAmount || 0)}
								listItem={false}
							/>
						</li>
					) : null}

					{!hideTransporter && formattedOrder.transporterAmount && formattedOrder.transporterAmount > 0 ? (
						<PriceSummaryRow text={orderOverviewTransportCosts} price={formattedOrder.transporterAmount} pricePrefix={showTransporterFromPrice ? from : ""} />
					) : null}
					{formattedOrder.totalDiscountAmount && formattedOrder.totalDiscountAmount < 0 ? (
						<PriceSummaryRow text={orderOverviewDiscountCosts} price={formattedOrder.totalDiscountAmount} />
					) : null}
					<PriceSummaryRow
						text={orderOverviewPriceSum}
						price={formattedOrder.total.grossAmount < 0 ? 0 : formattedOrder.total.grossAmount}
						bold={!(formattedOrder.paidAmount > 0)}
					/>
					<PriceSummaryRow text={orderOverviewVAT} price={formattedOrder.subtotal.taxAmount || 0} />

					{formattedOrder.paidAmount > 0 && (
						<li className="mt-3">
							{formattedOrder.paidAmount > 0 && <PriceSummaryRow text={orderOverviewAlreadyPaid} price={formattedOrder.paidAmount} listItem={false} />}
							{formattedOrder.paidAmount > 0 && formattedOrder.payAmount >= 0 && (
								<PriceSummaryRow text={orderOverviewOpenAmount} price={formattedOrder.payAmount} bold listItem={false} />
							)}
						</li>
					)}

					{formattedOrder.payAmount < 0 && (
						<li className="mt-3">
							<PriceSummaryRow text={orderOverviewCreditAmount} price={Math.abs(formattedOrder.payAmount)} bold listItem={false} />
						</li>
					)}
				</ol>
			</div>
		</div>
	)
}
